import { useSelector } from "react-redux";
import { _t, i18n } from "app/i18n/i18n";
import { isProdEnv, getParam } from "lib/routing";
import { useLocation } from "react-router";
import { features } from "app/features";

export const useAdverts = () => {
  const advertsJson = useSelector((state) => state.misc.adverts);

  let [, , , , product] = useLocation().pathname.split("/");
  const assetClass = useLocation().pathname.split("/")[1];
  let regionParam = getParam("regions");
  let region = regionParam ? _t(regionParam) : regionParam;

  if (getParam("ads") === "0") return [];
  const language = i18n.getLanguage();
  region = region && region.replace("Global-Focus", "Global");

  return findAdverts(advertsJson, {assetClass, region, product, language});
};

export const findAdverts = (adverts = [], { assetClass, region, product, language }) => {
  const assetClassExclFocus = assetClass?.replace(" Focus", "");

  try {
    const filteredAds = adverts
      .filter((ad) => ad.active !== "false")
      .filter((ad) => new Date() > new Date(ad.dateFrom) || !isProdEnv)
      .filter((ad) => new Date() < new Date(ad.dateTo))
      .filter((ad) => ad.language === language)
      .filter((ad) => contains(ad.assetClass, assetClassExclFocus))
      .filter((ad) => contains(ad.region, region))
      .filter((ad) => contains(ad.product, product))
      .filter((ad) => (isHomepage(assetClass) ? contains(ad.assetClass, "Home") : true))
      .map((ad) => {
        ad.cardType = "advert";
        return ad;
      });

    if (features.sortAdsByRunningOrder) {
      filteredAds.sort((ad1, ad2) => ad1.runningOrder - ad2.runningOrder);
    }

    return filteredAds;

    /*
    // Complex Ad matching: show only the most relevant ad for a particular section
    // Prioritise exact matches by all metrics, then product, then region, then asset, then general Ads.
    
    const directMatch = activeAds.filter((ad) => ad.assetClass === assetClass && ad.region === region && ad.product === product);
    const productMatch = activeAds.filter((ad) => ad.assetClass === assetClass && ad.region === "All" && ad.product === product);
    const regionMatch = activeAds.filter((ad) => ad.assetClass === assetClass && ad.region === region && ad.product === "All");
    const assetMatch = activeAds.filter((ad) => ad.assetClass.includes(assetClass) && ad.region === "All" && ad.product === "All");
    const generalMatch = activeAds.filter((ad) => ad.assetClass === "All" && ad.region === "All" && ad.product === "All");

    if (directMatch.length) return directMatch;
    else if (productMatch.length) return productMatch;
    else if (regionMatch.length) return regionMatch;
    else if (assetMatch.length) return assetMatch;
    else if (generalMatch.length) return generalMatch;
    return [];
 */
  } catch (err) {
    console.warn("Error finding adverts", err);
  }
};

export const contains = (csvString = "All", item) => {
  if (!Array.isArray(csvString)) {
    return !item || csvString === null || csvString === "All" || csvString.split(/, */).includes(item);
  } else {
    return csvString.some(
      (csvItem) => !item || csvItem === null || csvItem === "All" || csvItem.split(/, */).includes(item)
    );
  }
};

const isHomepage = (assetClass) => !assetClass; // any page (latest-research, your-research, most popular) which has no asset class in URL
